<template>
  <div class="modal">
    <div
      class="modal-content shadow-lg"
      :class="{ 'bg-lightgray-lightest': grayBg, 'bg-white': !grayBg }"
    >
      <div class="header">
        <slot name="header" />
      </div>
      <div class="body">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalWrapper",
  props: {
    grayBg: Boolean
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: block;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.4);

  z-index: 99;

  .modal-content {
    position: fixed;
    top: 50%;
    width: calc(100% - 1.5rem);
    transform: translateY(-50%);

    @apply mx-3;

    @screen md {
      width: auto;
      left: 50%;
      transform: translate(-50%, -50%);
      @apply mx-0;
    }

    .header {
      @apply p-5 text-white text-center uppercase bg-red;
    }

    .body {
      @apply pb-4 px-3 pt-5;

      @screen lg {
        @apply p-6;
      }
    }
  }
}
</style>
